import Card, { ICardProps } from "components/Card";
import { CheckedFeature } from "components/pricingoptions/CheckedFeature";

import { cx } from "utils";


type IPricingOptionCardProps = {
  recommended?: boolean;
  body?: string | JSX.Element;
  features?: string[];
  error?: string;
} & Pick<ICardProps, "title" | "footer">;

export function PricingOptionCard(
  {
    recommended,
    body,
    features,
    error,
    ...cardProps
  }: IPricingOptionCardProps
) {
  return (
    <Card
      { ...cardProps }
      className={ cx("min-w-[440px] w-full", recommended && "bg-brandPrimary-50") }
    >
      <div className="flex flex-col gap-y-4 justify-start h-full">
        <div className="text-sm">
          { body }
        </div>
        { features && (
          <div className="text-sm flex flex-col gap-y-2">
            { features.map((feature, i) => <CheckedFeature key={ "feature-" + i }>{ feature }</CheckedFeature>)}
          </div>
        ) }
        { error && (
          <div className="text-sm text-red-600">{ error }</div>
        ) }
      </div>
    </Card>
  );
}
